
<fieldset>
    <div class="row">
        <div class="col-24">
            <div *ngIf="visibleFrom2026 && !isExternalAgentEnrl" class="detail-info">
                <input type="checkbox"
                       class="option__input"
                       id="poBox-Check"
                       [(ngModel)]="checked"
                       [disabled]="disabled"
                       (ngModelChange)="onPOBoxChecked($event)" />
                <label for="poBox-Check">Check if enrollee is currently experiencing homelessness</label>
            </div>
        </div>
        </div>
        <legend>{{this.topAddressName}}</legend>
        <ConfigurableAddress id="top-address" [states]="states" [address]="topAddress" [addressLinePrefix]="topAddressLinePrefix" [allowPOBoxes]="allowPOBoxes"
                             (onValueChange)="updateTopAddress($event)" [disabled]="disabled">
        </ConfigurableAddress>
        <MaskedValidatedTextField *ngIf="showPhone" class="field" [label]="'Phone Number'" id="phonenum" [text]="phone.Phone" (onValueChange)="phone.Phone=$event"
                                  [maxlength]="10" [helperText]="'Format ##########'" [inputMask]="phoneNumberInputMask" [validators]="[numericValidator]">
        </MaskedValidatedTextField>
        <MaskedValidatedTextField *ngIf="showCellPhone" class="field" [label]="'Cell Number'" id="cellnum" [text]="cellPhone.Phone" (onValueChange)="cellPhone.Phone=$event"
                                  [maxlength]="10" [helperText]="'Format ##########'" [inputMask]="phoneNumberInputMask" [validators]="[numericValidator]">
        </MaskedValidatedTextField>
</fieldset>

<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField class="field field--single"
                                [label]="'Long-Term Care Facility Name (if applicable)'"
                                id="LTC-facility-name"
                                [text]="LTCFacilityName"
                                [disabled]="disabled"
                                (onValueChange)="onLTCFacilityNameChange.emit($event)">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <MaskedValidatedTextField class="field" [label]="'Long-Term Care Facility Phone'" id="LTC-facility-phone" [text]="LTCFacilityPhone"
                                      [disabled]="disabled" (onValueChange)="onLTCFacilltyPhoneChange.emit($event)"
                                      [maxlength]="10" [inputMask]="phoneNumberInputMask">
            </MaskedValidatedTextField>
        </div>
    </div>
</div>

<fieldset>
    <legend>{{this.bottomAddressName}}</legend>
    <div class="row">
        <div class="col-24">
            <div class="detail-info">
                <input type="checkbox"
                       class="option__input"
                       id="same-as-address"
                       [checked]="topAddress.sameAddress"
                       [disabled]="disabled"
                       (click)="clickOnSameAsTopAddress()" />
                <label for="same-as-address">{{this.bottomAddressName}} is the same as Permanent Address</label>
            </div>
        </div>
    </div>
    <ConfigurableAddress id="bottom-address" [states]="allStates" [address]="bottomAddress" [addressLinePrefix]="bottomAddressLinePrefix"
                         [disabled]="topAddress.sameAddress || disabled" (onValueChange)="onBottomAddressChange.emit($event)">
    </ConfigurableAddress>
</fieldset>
